var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "phone-input",
        {
          "is-focused": _vm.isFocused,
          "is-errored": _vm.isValid === false,
          "is-valid": _vm.isValid,
          "is-filled": _vm.value !== "" && typeof _vm.value !== "object",
          "is-disabled": _vm.disabled,
        },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "phone-input__container" },
        [
          _c(
            "div",
            {
              ref: "selectWrapper",
              staticClass: "phone-input__select-wrapper",
            },
            [
              _c("z-select", {
                class: { "is-disabled": _vm.disabled },
                attrs: { clearable: false, data: _vm.preparedPhoneMasksData },
                on: { input: _vm.onCountryChange },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("z-input", {
            ref: "input",
            attrs: {
              placeholder: _vm.placeholder,
              name: _vm.name,
              type: "tel",
              required: _vm.required,
              mask: _vm.currentMask,
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("span", {
            staticClass: "phone-input__error",
            domProps: { innerHTML: _vm._s(_vm.error) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }